<template>

    <v-modal
        :open="open"
        class="c-modal_remove_attachment">
        <h2>Usuń załącznik</h2>

        <p class="c-modal_remove_attachment__content">
            Wybrany plik zostanie usunięty bezpowrotnie i utracisz do niego dostęp.<br><br>
            W każdym momencie możesz zarchiwizować dane wizyty wraz z załącznikami eksportując dokumentację pacjenta za
            pomocą funkcji dostępnej w
            <router-link :to="{ name: 'Settings' }">ustawieniach EDF</router-link>
            .
        </p>
        <p class="c-modal_remove_attachment__question">Czy na pewno chcesz usunąć wybrany załącznik?</p>
        <div>
            <v-btn
                type="red-white"
                @click="cancel">
                Anuluj
            </v-btn>
            <v-btn
                type="red"
                @click="ok"
                has-loader
                :loading="isLoading">
                Tak, usuń
            </v-btn>
        </div>
    </v-modal>

</template>


<script>

import VModal from 'Components/VModal'
import VBtn from 'Components/VBtn'

export default {

    name: 'VisitAttachmentsRemoveModal',

    data() {
        return {
            attachmentId: null,
            attachmentType: null,
            open: false,
            isLoading: false
        }
    },

    methods: {
        cancel() {
            this.open = false
        },

        ok() {
            this.isLoading = true
            this.$store.dispatch('VISIT_ATTACHMENTS_DELETE', {
                type: this.attachmentType,
                id: this.attachmentId
            }).then(() => {
                this.open = false
                this.$emit('success')
            }).catch((error) => {
                this.isLoading = false
                this.$alert.error('Załączniki', error.response.data.message)
                this.open = false
                this.$emit('failure')
            })
        },
    },

    mounted() {
        this.$on('open', (id, type) => {
            this.attachmentId = id
            this.attachmentType = type
            this.open = true
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        VModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_remove_attachment {
    text-align: center;

    &__content {
        margin: 1.5rem 0;
    }
    &__question {
        color: $c-red;
        margin-bottom: 2rem;
    }
    button {
        margin: .5rem;
    }
}

</style>
